import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const TableWidgetIcon = forwardRef<SVGSVGElement, IconProps>(function TableWidgetIcon(
  { height = 32, width = 32, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 4.11429C30 4.72969 29.5287 5.22857 28.9474 5.22857H3.05263C2.47128 5.22857 2 4.72969 2 4.11429C2 3.49888 2.47128 3 3.05263 3L28.9474 3C29.5287 3 30 3.49888 30 4.11429Z"
        fill="#6C4FC2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.23577 10.8C7.23577 11.4154 6.72618 11.9143 6.09756 11.9143H3.13821C2.50959 11.9143 2 11.4154 2 10.8C2 10.1846 2.50959 9.68572 3.13821 9.68572H6.09756C6.72618 9.68572 7.23577 10.1846 7.23577 10.8Z"
        fill="#6C4FC2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1003 10.8C17.1003 11.4154 16.5907 11.9143 15.9621 11.9143H11.4092C10.7806 11.9143 10.271 11.4154 10.271 10.8C10.271 10.1846 10.7806 9.68572 11.4092 9.68572H15.9621C16.5907 9.68572 17.1003 10.1846 17.1003 10.8Z"
        fill="#EF145D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 10.8C30 11.4154 29.4904 11.9143 28.8618 11.9143H21.2737C20.6451 11.9143 20.1355 11.4154 20.1355 10.8C20.1355 10.1846 20.6451 9.68572 21.2737 9.68572H28.8618C29.4904 9.68572 30 10.1846 30 10.8Z"
        fill="#6C4FC2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.23577 16C7.23577 16.6154 6.72618 17.1143 6.09756 17.1143H3.13821C2.50959 17.1143 2 16.6154 2 16C2 15.3846 2.50959 14.8857 3.13821 14.8857H6.09756C6.72618 14.8857 7.23577 15.3846 7.23577 16Z"
        fill="#6C4FC2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1003 16C17.1003 16.6154 16.5907 17.1143 15.9621 17.1143H11.4092C10.7806 17.1143 10.271 16.6154 10.271 16C10.271 15.3846 10.7806 14.8857 11.4092 14.8857H15.9621C16.5907 14.8857 17.1003 15.3846 17.1003 16Z"
        fill="#EF145D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 16C30 16.6154 29.4904 17.1143 28.8618 17.1143H21.2737C20.6451 17.1143 20.1355 16.6154 20.1355 16C20.1355 15.3846 20.6451 14.8857 21.2737 14.8857H28.8618C29.4904 14.8857 30 15.3846 30 16Z"
        fill="#6C4FC2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.13821 20.0857H6.09756C6.72618 20.0857 7.23577 20.5846 7.23577 21.2C7.23577 21.8154 6.72618 22.3143 6.09756 22.3143H3.13821C2.50959 22.3143 2 21.8154 2 21.2C2 20.5846 2.50959 20.0857 3.13821 20.0857Z"
        fill="#6C4FC2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1003 21.2C17.1003 21.8154 16.5907 22.3143 15.9621 22.3143H11.4092C10.7806 22.3143 10.271 21.8154 10.271 21.2C10.271 20.5846 10.7806 20.0857 11.4092 20.0857H15.9621C16.5907 20.0857 17.1003 20.5846 17.1003 21.2Z"
        fill="#EF145D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 21.2C30 21.8154 29.4904 22.3143 28.8618 22.3143H21.2737C20.6451 22.3143 20.1355 21.8154 20.1355 21.2C20.1355 20.5846 20.6451 20.0857 21.2737 20.0857H28.8618C29.4904 20.0857 30 20.5846 30 21.2Z"
        fill="#6C4FC2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 27.8857C30 28.5011 29.5287 29 28.9474 29H3.05263C2.47128 29 2 28.5011 2 27.8857C2 27.2703 2.47128 26.7714 3.05263 26.7714H28.9474C29.5287 26.7714 30 27.2703 30 27.8857Z"
        fill="#6C4FC2"
      />
    </SvgStyled>
  );
});
